var jsCookies = require("js-cookie");

function getPsuedoGuid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + "-" + s4() + s4() + s4();
}

var SESSION_COOKIE_NAMES = {
  sessionID: "posi-log-session-uid",
  email: "posi-session-email",
  country: "posi-session-country",
  tracepartsUserID: "posi-session-traceparts-id",
};

function _maybeInitSession() {
  var curSessionID = jsCookies.get("posi-log-session-uid");
  if (!curSessionID)
    jsCookies.set("posi-log-session-uid", getPsuedoGuid(), { expires: 1 }); // session IDs should reset each day
}

function getSession(param) {
  _maybeInitSession();

  if (!param) {
    var sessionData = {};
    $.each(SESSION_COOKIE_NAMES, function (propName, cookieName) {
      sessionData[propName] = jsCookies.get(cookieName);
    });

    return sessionData;
  } else {
    return jsCookies.get(SESSION_COOKIE_NAMES[param]);
  }
}

function setSession(param, value) {
  var cookieName = SESSION_COOKIE_NAMES[param];

  _maybeInitSession();

  if (!cookieName) {
    console.error("Posi session param doesnt exist: " + param);
    return;
  }

  if (cookieName == "sessionID") {
    console.error("Cannot set posi session ID directly.");
    return;
  }

  jsCookies.set(cookieName, value, {
    expires: 365,
  });
}

module.exports = {
  getSession: getSession,
  setSession: setSession,
};
